export const MONTHS = ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];

export const PROFILES = {
  uniforme: Array(12).fill(+(100 / 12).toFixed(4)),
  jardin: [0, 0, 3, 8, 13, 18, 22, 20, 11, 4, 1, 0],
};

// `sewage: true` = cette eau part vers l'assainissement après usage (WC, lave-linge) — utilisé
// à l'étape ROI pour savoir si l'eau de pluie n'évite que la part distribution (sewage) ou
// aussi la part assainissement (non-sewage, ex. arrosage/lavage extérieur).
// `category` identifie le type d'usage indépendamment du nom (modifiable par l'utilisateur) :
// pilote les recommandations non bloquantes du budget (bascule eau de ville, filtration...).
export const DEFAULT_USAGES = [
  { id: 'wc', name: 'WC / sanitaires', volume: 9, profile: 'uniforme', custom: null, enabled: true, sewage: true, category: 'wc' },
  { id: 'garden', name: 'Arrosage jardin / potager', volume: 15, profile: 'jardin', custom: null, enabled: true, sewage: false, category: 'garden' },
  { id: 'washer', name: 'Lave-linge', volume: 4, profile: 'uniforme', custom: null, enabled: true, sewage: true, category: 'washer' },
  { id: 'outdoor', name: 'Lavage extérieur (voiture, terrasse)', volume: 2, profile: 'uniforme', custom: null, enabled: false, sewage: false, category: 'outdoor' },
  { id: 'bins', name: 'Nettoyage des poubelles', volume: 1, profile: 'uniforme', custom: null, enabled: true, sewage: false, category: 'other' },
];

export const normalizedProfile = (usage) => {
  if (usage.profile === 'custom' && usage.custom) return usage.custom;
  return PROFILES[usage.profile];
};

/**
 * Le profil "custom" accepte soit des pourcentages (somme 100), soit des parts/poids
 * relatifs libres (ex. 1,1,2,3,3,2,1...) — dans les deux cas on normalise par la somme
 * du profil, donc peu importe l'échelle saisie par l'utilisateur.
 */
export const computeMonthlyNeed = (usages) => {
  const monthly = Array(12).fill(0);
  usages.filter(u => u.enabled).forEach(u => {
    const p = normalizedProfile(u);
    const sum = p.reduce((a, b) => a + b, 0);
    for (let m = 0; m < 12; m++) {
      const share = sum > 0 ? p[m] / sum : 0;
      monthly[m] += u.volume * share;
    }
  });
  return monthly;
};

export const customProfileSum = (usage) => (usage.custom || []).reduce((a, b) => a + b, 0);

/** Y a-t-il au moins un usage actif de cette catégorie ? Pilote les recommandations non bloquantes du budget. */
export const hasActiveCategory = (usages, category) => usages.some(u => u.enabled && u.category === category);

/**
 * Parse un texte collé (depuis Excel/Sheets) en 12 valeurs numériques : séparateurs
 * espace/tabulation/point-virgule/retour à la ligne (pas la virgule, souvent utilisée
 * comme séparateur décimal en France : "12,5" doit rester un seul nombre).
 * @returns {number[]|null} 12 valeurs, ou null si le nombre de valeurs détecté n'est pas 12
 */
export const parsePastedProfile = (raw) => {
  const tokens = raw.trim().split(/[\s;]+/).filter(Boolean);
  const nums = tokens.map(t => parseFloat(t.replace(',', '.'))).filter(n => !isNaN(n));
  return nums.length === 12 ? nums : null;
};
